let _activeValidClientIds = [];
export const setActiveValidClientIds = (vf) => {
  _activeValidClientIds = vf;
};
export const getActiveValidClientIds = () => {
  return _activeValidClientIds;
};